import { Permissions, usePermission } from 'src/rbac';

/**
 * May this user edit the therapy plan? Drives the WeekView "Edit" toggle and, in
 * TherapyCard 2.0, whether planner cells are interactive (background + pointer-events).
 *
 * Migrated (Segment B) from the legacy `permissionData.includes('Update Therapy Planning')`
 * display-name check to the instrumented `Permissions.UPDATE_THERAPY_PLANNING` scopeKey. Note
 * the key remap: the legacy paths.ts key is `UPDATE_THERAPIST_PLANNING`, whose display name
 * still equals the catalog display name for scopeKey `UPDATE_THERAPY_PLANNING`
 * (parity-verified in rbac-parity.test.ts). THIN-8081 renamed that display name from
 * "Update Therapy Planning" to "Update/Edit Therapy Planning" in catalog 5.20.0; gating on the
 * scopeKey means the rename cannot reach this check. Behavior is preserved; the check now
 * emits RUM telemetry.
 */
export function useUpdateTherapyPlanningGate(): boolean {
  return usePermission(Permissions.UPDATE_THERAPY_PLANNING);
}
